import { SignatureFields } from "./SignatureFields";

type PrescribeDataProps = {
  note: {
    intervention_reaction?: string;
    patient_reported?: string;
    prescriber_interventions?: string;
  } & Parameters<typeof SignatureFields>[0]["note"];
};

export function PrescribeData({ note }: PrescribeDataProps) {
  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Patient Reported</label>
          <p>{note.patient_reported}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Prescriber Interventions or Education</label>
          <p>{note.prescriber_interventions}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Intervention or Education Reaction</label>
          <p>{note.intervention_reaction}</p>
        </div>
      </div>

      <SignatureFields note={note} />
    </div>
  );
}
